<script>
	import {replace} from "svelte-spa-router";
    import Controlador from "../controlador.svelte";
	import {onMount,beforeUpdate} from "svelte";
	import {docs,logueo} from "../store.js";
	import ItemClientes from "../componentes/itemCliente.svelte";
import ItemCliente from "../componentes/itemCliente.svelte";
	let c;
	let meses = [
		{nombre:"Enero",val:"0" },
		{nombre:"Febrero",val:"1" },
		{nombre:"Marzo",val:'2' },
		{nombre:"Abril",val:'3' },
		{nombre:"Mayo",val:'4' },
		{nombre:"Junio",val:'5' },
		{nombre:"Julio",val:'6' },
		{nombre:"Agosto",val:'7' },
		{nombre:"Septiembre",val:'8' },
		{nombre:"Octubre",val:'9' },
		{nombre:"Noviembre",val:'10' },
		{nombre:"Diciembre",val:'11' }
	];
	let local = "";
	let locales = [];
	let botones = [
		{nombre:"Volver",icon:"ri-arrow-left-line",href:"#/home"},
		{nombre:"Sorteo",icon:"ri-recycle-line", href:"#/sorteo"}
	]
	let filtro = "";
	let filtroMes = "";
	let filtroInscripcion;
	let filtroServicio = "";
	let listaClientes = [];
	onMount(()=>{
		console.log("nueva version");
		locales = $docs.filter((el)=>el._id.includes("local:"));
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (listaClientes){
			listaClientes = $docs
			.filter((el)=>el._id.includes("cliente:"))
			.filter((el)=> el.nombre && el.nombre.toLowerCase().includes(filtro.toLowerCase()))
			if (local != ""){
				listaClientes = listaClientes.filter((el)=>(el.documentos[0].local != undefined) && (el.documentos[0].local == local))
			}
			if (filtroMes != ""){
				console.log(filtroMes);
				listaClientes = listaClientes.filter((el)=>{
					let mesCumple = new Date(el.cumple).getMonth();
					return (mesCumple == filtroMes);
				})
			}
			if (filtroInscripcion != undefined){
				listaClientes = listaClientes.filter((el)=>{
					let f = new Date(filtroInscripcion);
					let fCliente = new Date(el.documentos[0].fecha);
					f.setHours(0,0,0,0);
					fCliente.setHours(0,0,0,0);
					fCliente.setDate(fCliente.getDate() - 1);
					return (fCliente.getTime() == f.getTime());
				});
			}
			if (filtroServicio != ""){
				listaClientes = listaClientes.filter((el)=>el.documentos[0].cuerpo[1].nombre == filtroServicio);
			}
			listaClientes = listaClientes.sort((a,b)=>{
				let dato = new Date(b.documentos[0].fecha) - new Date(a.documentos[0].fecha);
				return dato;
			});
		}
	})
</script>
<Controlador bind:this={c}></Controlador>
<div class="p-4 w-screen max-w-full h-full min-h-screen  flex flex-col items-center">
	<div class="w-full sm:w-3/4 flex items-center justify-between">
		{#each botones as b}
			<a href={b.href} class="w-1/3 m-2 text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow ">
				<i class={b.icon} />
				{b.nombre}
		</a>
		{/each}
	</div>
	<div class="w-full flex flex-col items-center justify-start sm:flex-row sm:items-start sm:w-3/4">
		<select bind:value={filtroMes} class="w-full p-2 m-2 p-2 rounded shadow">
			<option value="">Cumpleaños</option>
			{#each meses as mes}
				<option value={mes.val}>{mes.nombre}</option>
			{/each}
		</select>
		<input bind:value={filtroInscripcion} type="date" class="w-full p-2 m-2 p-2 rounded shadow" />
		<select bind:value={filtroServicio} class="w-full p-2 m-2 p-2 rounded shadow">
			<option value="">Servicio</option>
			<option value="Tatuaje">Tatuaje</option>
			<option value="Perforación">Perforación</option>
		</select>
		<select bind:value={local} class="w-full p-2 m-2 p-2 rounded shadow">
				<option value="" selected={local == ""}>Sucursal</option>
			{#each locales as l}
				<option value={l.nombre} selected={l.nombre == local}>{(l.nombre == "Guemes"? "Güemes":l.nombre)}</option>
			{/each}
		</select>
	</div>
	<input bind:value={filtro} class="w-full m-2 p-2 sm:w-3/4 rounded shadow" type="text" placeholder="Filtro" />
	{#each listaClientes as i}
		<ItemCliente cliente={i} />
	{/each}
</div>
